import { useEffect, useState } from "react";
import { ArrowRight, Menu, Phone, X } from "lucide-react";
import { Logo } from "./Logo";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`site-header ${scrolled ? "scrolled" : ""}`} data-testid="site-header">
      <div className="container header-inner">
        <Logo light />
        <nav className={`nav-links ${open ? "open" : ""}`} data-testid="main-navigation">
          <a data-testid="nav-services-link" href="#services" onClick={() => setOpen(false)}>Services</a>
          <a data-testid="nav-reviews-link" href="#reviews" onClick={() => setOpen(false)}>Reviews</a>
          <a data-testid="nav-faq-link" href="#faq" onClick={() => setOpen(false)}>FAQ</a>
          <a data-testid="nav-contact-link" href="#contact" onClick={() => setOpen(false)}>Contact</a>
          <a className="nav-phone" data-testid="nav-phone-link" href="tel:+919135667888"><Phone size={14} /> 91356 67888</a>
        </nav>
        <div className="header-actions">
          <a data-testid="nav-quote-button" className="btn btn-gold btn-sm" href="#quote">Get a free quote <ArrowRight size={15} /></a>
          <button data-testid="mobile-menu-button" className="menu-toggle" onClick={() => setOpen(!open)} aria-label="Toggle navigation">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
    </header>
  );
};
